import { defineFcm } from '../shared/factory';

export const FCM_DM_ABOUT_PAGE = defineFcm('dm_about_page').asBoolean().withDefault(false).toConfig();
